<template>
  <footer class="edu-footer-area">
    <div class="container">
      <div class="footer-top-area ptb-100">
        <div class="row">
          <div class="col-lg-4 col-md-6 col-sm-6">
            <div class="single-footer-widget">
              <router-link to="/" class="logo">
                <img src="../../assets/img/logo/logo-tmt.png" alt="image" />
              </router-link>
              <p>We are maritime training service based on Indonesia</p>
              <ul class="social-links">
                <li>
                  <a
                    href="https://www.facebook.com/profile.php?id=61551355237245"
                    target="_blank"
                  >
                    <i class="bx bxl-facebook"></i>
                  </a>
                </li>
                <li>
                  <a href="https://x.com/TelanusaMT" target="_blank">
                    <i class="bx bxl-twitter"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/telanusamaritimetraining/"
                    target="_blank"
                  >
                    <i class="bx bxl-instagram"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-4 offset-md-4 col-md-6 col-sm-6">
            <div class="single-footer-widget pl-5">
              <h3>Contact Us</h3>
              <ul class="links-list">
                <li><router-link to="/services-details">+ 6281355585758</router-link></li>
                <li>
                  <router-link to="/services-details"
                    >service@telanusamaritimetraining.com</router-link
                  >
                </li>
                <li>
                  <router-link to="/services-details"
                    >Jln. Bromo 4 Blok A576 RT 03 RW 01 Bintara Jaya</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="pr-line"></div>
      <div class="footer-bottom-area">
        <p>
          © Copyright {{ currentYear }} |
          <a href="#" target="_blank">Telanusa Maritime Training</a> | All Rights Reserved
        </p>
      </div>
    </div>
  </footer>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "MainFooter",
  setup() {
    const currentYear = ref(new Date().getFullYear());

    return {
      currentYear,
    };
  },
});
</script>
